/**
 * Resolves API base URL for browser builds. When the app is served by the backend
 * (production), use a relative /api path on the same host.
 */
export function getApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL;
  const fromEnv = raw ? String(raw).replace(/\/+$/, "") : "";
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const onLoopback = hostname === "localhost" || hostname === "127.0.0.1";

  if (onLoopback) {
    return fromEnv && !fromEnv.startsWith("/")
      ? fromEnv
      : fromEnv || "http://localhost:8001/api";
  }

  if (fromEnv) {
    if (fromEnv.startsWith("/")) {
      return fromEnv;
    }
    if (!/localhost|127\.0\.0\.1/i.test(fromEnv)) {
      return fromEnv;
    }
  }

  if (typeof window !== "undefined") {
    return `${window.location.origin}/api`;
  }

  return "/api";
}
